//@flow
import React from 'react';
import { type Element as ReactElement } from 'react';
import { type Currencies } from '../../../utilities/types';
import EmptyTable from '../../../components/EmptyTable';
import TableLoader from '../../../components/TableLoader';

// type TableRowProps = {
//   data: Array<{}>,
//   currencies: {},
//   currency: string,
//   color: string,
//   currencyName: string
// };
type Props = {
  tableBodyOptions: {
    text: string,
    model: string,
    img: string
  },
  failedLoad: boolean,
  loading: boolean,
  updateTableLoading?: boolean,
  tableData: Array<{ currency: string, status: string, id: number }>,
  currencies?: Currencies,
  TableRow: ReactElement<any>
};

const TableBody = (props: Props) => {
  if (props.failedLoad) {
    return (
      <EmptyTable error columns={7} model={props.tableBodyOptions.model} />
    );
  } else if (props.loading) {
    return <TableLoader columns={7} />;
  } else if (props.updateTableLoading) {
    return <TableLoader columns={7} />;
  } else if (props.tableData.length === 0) {
    return (
      <EmptyTable
        text={props.tableBodyOptions.text}
        columns={7}
        model={props.tableBodyOptions.model}
        img={props.tableBodyOptions.img}
      />
    );
  } else {
    return props.tableData.map((data, index) => (
      <React.Fragment key={index}>
        {/* $FlowFixMe */}
        {React.cloneElement(props.TableRow, {
          data,
          currencies: props.currencies,
          index,
          ...props
        })}
      </React.Fragment>
    ));
  }
};

const memoized = React.memo<Props>(TableBody);
export default memoized;
